import React, { useState, useEffect } from 'react';
import { client, urlFor } from '../sanityClient';
import SEO from '../components/SEO';
import ContactCTA from '../components/ContactCTA';
import './Catering.css';

function Catering() {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const query = '*[_type == "catering" && featured == true] | order(order asc)';
    client.fetch(query).then(data => {
      setOptions(data);
      setLoading(false);
    }).catch(err => {
      console.error(err);
      setLoading(false);
    });
  }, []);

  return (
    <div className="catering-page">
      <SEO
        title="케이터링 | Catering"
        description="가든포에트 웨딩 케이터링. 프렌치, 한식, 퓨전 등 다양한 제휴 케이터링으로 특별한 웨딩 다이닝."
        path="/catering"
      />
      <section className="catering-hero">
        <div className="container">
          <div className="hero-content fade-in">
            <h1 className="page-hero-title">CATERING PARTNERS</h1>
            <p className="hero-subtitle">Curated by Garden Poète</p>
          </div>
        </div>
      </section>

      <section className="catering-intro">
        <div className="container">
          <div className="intro-content fade-in">
            <p>예산에 맞춰 선택하세요.</p>
            <p>
              부담 없이 즐기는 도시락,<br />
              정원 아래에서 나누는 브런치,<br />
              특별한 순간을 위한 프리미엄.
            </p>
            <p>
              당신이 원하는 방식으로<br />
              음식을 준비합니다.
            </p>
            <p className="catering-notice">
              케이터링 업체는 예식 일정에 따라 예약 가능 여부가 다릅니다.<br />
              예식 예약 전 업체와 먼저 일정을 조율해 주시길 권장드립니다.<br />
              소개된 업체는 Garden Poète의 추천이며, 자유롭게 다른 업체를 이용하셔도 됩니다.
            </p>
          </div>
        </div>
      </section>

      <section className="catering-section">
        <div className="container">
          {loading ? (
            <p className="loading-text">로딩중...</p>
          ) : options.length > 0 ? (
            <div className="options-list">
              {options.map((option, index) => (
                <div key={option._id} className="option-showcase fade-in">
                  {option.images && option.images.length > 0 && (
                    <div className="instagram-grid">
                      {option.images
                        .filter(image => image && image.asset && image.asset._ref)
                        .map((image, imgIndex) => (
                          <div key={imgIndex} className="grid-item">
                            <img src={urlFor(image).width(400).url()} alt={`${option.name} ${imgIndex + 1}`} />
                          </div>
                        ))}
                    </div>
                  )}

                  <div className="option-content">
                    <h2>{option.name}</h2>
                    {option.subtitle && <p className="option-style">{option.subtitle}</p>}
                    {option.description && <p className="option-description">{option.description}</p>}
                    
                    <div className="contact-info">
                      {option.instagram && (
                        <p className="contact-item">
                          📷 {option.instagramUrl ? (
                            <a href={option.instagramUrl} target="_blank" rel="noopener noreferrer">
                              {option.instagram}
                            </a>
                          ) : option.instagram}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="no-option fade-in">
              <h2>케이터링 옵션 준비중</h2>
              <p>곧 Garden Poète의 케이터링 옵션을 소개해드립니다.</p>
            </div>
          )}
        </div>
      </section>

      <ContactCTA 
        title="케이터링 문의" 
        subtitle="당신의 예산과 취향에 맞는 케이터링을 함께 찾아갑니다"
      />
    </div>
  );
}

export default Catering;
